var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6839 0.354858H1.29032C0.567742 0.354858 0 0.9226 0 1.64518V11.9678C0 12.6903 0.567742 13.2581 1.29032 13.2581H18.7097C19.4323 13.2581 20 12.6903 20 11.9678V1.64518C19.9741 0.9226 19.4063 0.354858 18.6838 0.354858H18.6839ZM18.6839 11.9678H1.29032V1.64518H18.7097V11.9678H18.6839Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6129 4.92259H16.4387C16.8 4.92259 17.0839 4.63871 17.0839 4.27742C17.0839 3.91614 16.8 3.63226 16.4387 3.63226H11.6129C11.2517 3.63226 10.9678 3.91614 10.9678 4.27742C10.9678 4.63871 11.2517 4.92259 11.6129 4.92259Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6129 7.45158H15.071C15.4322 7.45158 15.7161 7.1677 15.7161 6.80642C15.7161 6.44514 15.4322 6.16125 15.071 6.16125H11.6129C11.2517 6.16125 10.9678 6.44514 10.9678 6.80642C10.9678 7.1677 11.2517 7.45158 11.6129 7.45158Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30283 10.0065C3.30283 10.3677 3.58671 10.6516 3.94799 10.6516C4.30927 10.6516 4.59315 10.3677 4.59315 10.0065C4.59315 8.92259 5.47052 8.04522 6.55439 8.04522C7.63827 8.04522 8.51564 8.92259 8.51564 10.0065C8.51564 10.3677 8.79952 10.6516 9.1608 10.6516C9.52208 10.6516 9.80596 10.3677 9.80596 10.0065C9.80596 8.7678 9.10914 7.70969 8.07693 7.16766C8.59301 6.72897 8.92854 6.08379 8.92854 5.36125C8.92854 4.04517 7.87043 2.98706 6.55435 2.98706C5.23827 2.98706 4.18015 4.04517 4.18015 5.36125C4.18015 6.08384 4.51569 6.729 5.03177 7.16766C3.99942 7.70969 3.30273 8.79351 3.30273 10.0065H3.30283ZM6.52863 4.27743C7.12214 4.27743 7.6125 4.7678 7.6125 5.3613C7.6125 5.9548 7.12214 6.44517 6.52863 6.44517C5.93513 6.44517 5.44476 5.9548 5.44476 5.3613C5.44476 4.7678 5.93495 4.27743 6.52863 4.27743Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/idCard.98e7df0c63c7b6d86c4ba52ceb0ec090.svg";
export { ForwardRef as ReactComponent };